import React from "react";

const Telephone = ({
  placeholder,
  name,
  className,
  validation,
  onBlur,
  onKeyPress,
  phoneStyle,
  value,
  id,
  onChange,
  disabled,
  maxlength,
  validationMsg,
  ...props
}) => {
  return (
    <>
      <input
        type="tel"
        name={name}
        className={className}
        placeholder={placeholder}
        ref={validation}
        onChange={onChange}
        disabled={disabled}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        style={phoneStyle}
        defaultValue={value}
        id={id}
        maxLength={maxlength}
        {...props}
      />
       {validationMsg && (
        <>
          <span className="error_msg">{validationMsg}</span>
        </>
      )}
    </>
  );
};
export default Telephone;
